import type { LeftMenuType } from 'redux/reducers/leftSideMenu'

import { app } from 'actions/app'
import { contacts } from 'actions/contacts'
import { filters } from 'actions/filters'
import clearListIcon from 'assets/image/icons/left-side-menu/clear-list.svg'
import clsx from 'clsx'

import './style.scss'

import { Link, useHistory, useParams } from 'react-router-dom'
import { useAppSelector } from 'shared/hooks'

import TooltipCustom from '../../atoms/tooltipCustom'
import TrialNotification from '../trialNotification'
import css from './LeftSideMenu.module.scss'

const linkBuilder = (type: LeftMenuType, id: string, archived = false) => {
	const link = archived ? '/archive' : '/campaigns'
	switch (type) {
		case 'campaign':
		case 'team':
			return `${link}/${id}`

		case 'contacts':
			return `/campaigns/${id}/contacts`

		default:
			return ''
	}
}

export function LeftSideMenu({
	className
}: {
	className?: string
}) {
	const active = useAppSelector(state => state.leftSideMenu.active),
		campaign = useAppSelector(state => state.campaign),
		leftSide = useAppSelector(state => state.leftSideMenu.leftSide)

	const { id } = useParams<{ id?: string }>()
	const { push } = useHistory()

	const bottomListActiveHandler = (item: any) => {
		if (leftSide.type === 'account') {
			return
		}
		if (id) {
			if (campaign.archive && item.link === '/archive') {
				return 'active semi-bold'
			}
			if (!campaign.archive && item.link === '/campaigns') {
				const campaign = leftSide.list?.find(item => item.id === id)
				return !campaign ? 'active semi-bold' : ''
			}
		} else {
			return active === item.id ? 'active semi-bold' : ''
		}
	}

	const clickOnLink = (item: { id: string }) => {
		app.changeActiveItem(item.id)
		contacts.changeContactsPage(0)
		push(`/campaigns/${item.id}`)
	}

	const onClickRecentImportItem = (item: { id: string }) => {
		app.changeActiveItem(item.id)
		filters.clearAllFilters()
		contacts.changeContactsPage(0)
	}

	return (
		<div className={clsx(className, css.root, 'left-menu')}>
			<div className={clsx(css.list, 'app-scroll')}>
				{leftSide.type === 'messaging' && (
					<Link
						className={`first-link text-list ${
							leftSide.type === 'messaging' ? 'active' : ''
						}`}
						to={leftSide.bottomList[0].link}
					>
						<div className='line-list__img-container'>
							<img alt={'pageIcon'} src={leftSide.bottomList[0].image} />
						</div>
						{leftSide.bottomList[0].title}
					</Link>
				)}
				{leftSide.type === 'account' && (
					<Link
						className={`first-link text-list ${
							leftSide.type === 'account' ? 'active' : ''
						}`}
						to={leftSide.bottomList[0].link}
					>
						<div className='line-list__img-container'>
							<img alt={'pageIcon'} src={leftSide.bottomList[0].image} />
						</div>
						{leftSide.bottomList[0].title}
					</Link>
				)}

				{leftSide.type === 'team' && leftSide.bottomList && (
					<>
						<Link
							className={`first-link text-list ${
								active === leftSide.bottomList[0].id && 'active'
							}`}
							to={leftSide.bottomList[0].link}
						>
							<div className='line-list__img-container'>
								<img alt={'pageIcon'} src={leftSide.bottomList[0].image} />
							</div>
							{leftSide.bottomList[0].title}
						</Link>
						<ul className='list'>
							{leftSide.bottomList.slice(1).map(item => {
								return (
									<li
										className={`text-list ${bottomListActiveHandler(item)}`}
										key={item.id}
									>
										<Link className={'text-list'} to={item.link}>
											<div className='line-list__img-container'>
												<img alt={'pageIcon'} src={item.image} />
											</div>
											{item.title}
										</Link>
									</li>
								)
							})}
						</ul>
					</>
				)}
				{leftSide.type === 'campaign' && (
					<>
						<Link
							className={`first-link text-list ${
								active === leftSide.bottomList[0].id ? 'active' : ''
							}`}
							to={leftSide.bottomList[0].link}
						>
							<div className='line-list__img-container'>
								<img alt={'pageIcon'} src={leftSide.bottomList[0].image} />
							</div>
							{leftSide.bottomList[0].title}
						</Link>
						<ul className='list'>
							{leftSide.bottomList.slice(1).map(item => {
								return (
									<li
										className={`text-list ${bottomListActiveHandler(item)}`}
										key={item.id}
									>
										<Link className={'text-list'} to={item.link}>
											<div className='line-list__img-container'>
												<img alt={'pageIcon'} src={item.image} />
											</div>
											{item.title}
										</Link>
									</li>
								)
							})}
						</ul>

						{leftSide.list && leftSide.list?.length > 0 && (
							<>
								<div className='recently-title'>{leftSide.label}</div>
								<ul>
									{leftSide.list?.map(item => {
										return (
											!item.archived && (
												<li
													className={`${active === item.id ? 'active' : ''}`}
													key={item.id}
												>
													{leftSide.type === 'contacts' ? (
														<Link
															className='text-list'
															onClick={() => onClickRecentImportItem(item)}
															to={`/contacts/import/${item.id}`}
														>
															<img
																alt={'clockIcon'}
																className='with-shift'
																src={clearListIcon}
															/>
															<TooltipCustom
																arrow={true}
																title={item.name.length > 24 ? item.name : ''}
															>
																<p
																	className={
																		item.name.length > 24
																			? 'ellipsis'
																			: 'left-list-text'
																	}
																>
																	{item.name}
																</p>
															</TooltipCustom>
														</Link>
													) : (
														<Link
															className='text-list'
															onClick={() => clickOnLink(item)}
															to={
																linkBuilder(
																	leftSide.type,
																	item.id,
																	item.archived
																) || ''
															}
														>
															<img
																alt={'clockIcon'}
																className='with-shift'
																src={clearListIcon}
															/>
															<TooltipCustom
																arrow={true}
																title={item.name.length > 24 ? item.name : ''}
															>
																<p
																	className={
																		item.name.length > 24
																			? 'ellipsis'
																			: 'left-list-text'
																	}
																>
																	{item.name}
																</p>
															</TooltipCustom>
														</Link>
													)}
												</li>
											)
										)
									})}
								</ul>
							</>
						)}
					</>
				)}
				{leftSide.type === 'contacts' && (
					<>
						<Link
							className={`first-link text-list margin-top ${
								active === leftSide.bottomList[0].id ? 'active' : ''
							}`}
							to={leftSide.bottomList[0].link}
						>
							<div className='line-list__img-container'>
								<img alt={'pageIcon'} src={leftSide.bottomList[0].image} />
							</div>
							{leftSide.bottomList[0].title}
						</Link>
						{leftSide.list && leftSide.list?.length > 0 && (
							<>
								{' '}
								<div className='recently-title'>{leftSide.label}</div>
								<ul>
									{leftSide.list?.map(item => {
										return (
											!item.archived && (
												<li
													className={`${active === item.id ? 'active' : ''}`}
													key={item.id}
												>
													{leftSide.type === 'contacts' ? (
														<Link
															className='text-list'
															onClick={() => onClickRecentImportItem(item)}
															to={`/contacts/import/${item.id}`}
														>
															<img
																alt={'clockIcon'}
																className='with-shift'
																src={clearListIcon}
															/>
															<TooltipCustom
																arrow={true}
																title={item.name.length > 24 ? item.name : ''}
															>
																<p
																	className={
																		item.name.length > 24
																			? 'ellipsis'
																			: 'left-list-text'
																	}
																>
																	{item.name}
																</p>
															</TooltipCustom>
														</Link>
													) : (
														<Link
															className='text-list'
															onClick={() => clickOnLink(item)}
															to={
																linkBuilder(
																	leftSide.type,
																	item.id,
																	item.archived
																) || ''
															}
														>
															<img
																alt={'clockIcon'}
																className='with-shift'
																src={clearListIcon}
															/>
															<TooltipCustom
																arrow={true}
																title={item.name.length > 24 ? item.name : ''}
															>
																<p
																	className={
																		item.name.length > 24
																			? 'ellipsis'
																			: 'left-list-text'
																	}
																>
																	{item.name}
																</p>
															</TooltipCustom>
														</Link>
													)}
												</li>
											)
										)
									})}
								</ul>{' '}
							</>
						)}
					</>
				)}
			</div>
			<TrialNotification />
		</div>
	)
}

export default LeftSideMenu
